import { motion } from 'motion/react'
import { cn } from '@/utils/helpers'

type SpeakingIndicatorProps = {
  isSpeaking: boolean
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
}

const sizeClasses = {
  sm: 'p-1',
  md: 'p-1.5',
  lg: 'p-2'
}

export const SpeakingIndicator = ({ isSpeaking, size = 'md', children }: SpeakingIndicatorProps) => {
  return (
    <div className="relative inline-block">
      {/* Ring pulsant animé */}
      <motion.div
        className={cn('absolute inset-0 rounded-full border-4 border-brand-primary', sizeClasses[size])}
        animate={isSpeaking ? 'speaking' : 'idle'}
        variants={{
          speaking: {
            scale: [1, 1.15, 1],
            opacity: [0.85, 1, 0.85],
            transition: {
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          },
          idle: {
            scale: 1,
            opacity: 0,
            transition: {
              duration: 0.3,
              ease: 'easeOut'
            }
          }
        }}
        style={{
          boxShadow: isSpeaking ? '0 0 30px rgba(59, 130, 246, 0.8)' : 'none'
        }}
      />

      {/* Avatar content */}
      {children}
    </div>
  )
}
